import { css, styled } from 'styled-components'

import {
  Breakpoints,
  Colors,
  pxToRem,
  Typography,
} from '@b-stock/fe-core/design-system'

import { fontFamilyInter } from '../ui'

const BUTTON_SIZE = pxToRem(28)

export const Container = styled.div`
  align-items: center;
  display: flex;
  gap: ${pxToRem(3)};
`

const buttonBase = css`
  ${Typography.Body4}
  align-items: center;
  background-color: ${Colors.Semantic.Neutral.white};
  border: ${pxToRem(1)} solid #e5e7eb;
  border-radius: 0.25rem;
  color: ${Colors.Semantic.Neutral.very_dark_grey};
  display: flex;
  font-family: ${fontFamilyInter};
  font-weight: 600;
  height: ${BUTTON_SIZE};
  justify-content: center;
  min-width: ${BUTTON_SIZE};
  padding: 0 0.625rem;

  &:disabled {
    cursor: default;
  }
`

export const PageButton = styled.button<{ $current?: boolean }>`
  ${buttonBase}
  cursor: ${(o) => (o.$current ? 'default' : 'pointer')};

  &:disabled {
    cursor: default;
  }

  ${(o) =>
    o.$current
      ? css`
          background-color: ${Colors.Semantic.BStock.default.lightBackground};
          border-color: ${Colors.Semantic.BStock.default.lightBackground};
          color: ${Colors.Semantic.Neutral.white};

          &:not(:disabled):hover {
            background-color: ${Colors.Semantic.BStock.onhover};
            border-color: ${Colors.Semantic.BStock.onhover};
          }
        `
      : css`
          &:not(:disabled):hover {
            background-color: ${Colors.Semantic.Neutral.light_grey};
            border-color: ${Colors.Semantic.Neutral.medium_grey};
          }
        `}
`

export const ArrowButton = styled.button`
  ${buttonBase}
  cursor: pointer;
  gap: 0.25rem;

  &:not(:disabled):hover {
    background-color: ${Colors.Semantic.Neutral.light_grey};
  }

  &:disabled {
    color: ${Colors.Semantic.Neutral.medium_grey};
  }
`

export const ArrowLabel = styled.span`
  @media ${Breakpoints.max.small} {
    display: none;
  }
`

export const Ellipsis = styled.span`
  ${buttonBase}
  cursor: default;
`
